import { useMemo } from "react";
import FilterMultiSelectBox from "./filterMultiSelectBox";
import { useSkillFilter } from "../filters/useSkillFilter";

const FilterSkill = ({
  talentFilter,
  talentFilterTags,
  skillCategorized,
  languageCategorized,
  onAddFilter,
}) => {

  const skillsList = useMemo(() => [
    {
      label: "Skills",
      options: skillCategorized.map(val => ({
        label: Object.keys(val)[0],
        value: Object.values(val)[0],
      })),
    },
    {
      label: "Languages Spoken",
      options: languageCategorized.map(val => ({
        label: Object.keys(val)[0],
        value: Object.values(val)[0],
      })),
    },
  ], [skillCategorized, languageCategorized]);

  const skillLabelMap = useMemo(() => {
    const map = {};

    skillsList.forEach(group => {
      group.options.forEach(opt => {
        map[opt.value] = opt.label;
      });
    });

    return map;
  }, [skillsList]);

  const {
    selectedSkills,
    setSelectedSkills,
    buildSkillFilter,
  } = useSkillFilter(talentFilter, talentFilterTags, skillLabelMap);

  const handleAdd = () => {
    const payload = buildSkillFilter();
    if (!payload) return;

    onAddFilter("skills", payload);
  };

  return (
    <FilterMultiSelectBox
      title="SKILLS (Select one or several)"
      label="Select skill or search"
      list={skillsList}
      selectedValue={selectedSkills}
      onChange={setSelectedSkills}
      onAddFilter={handleAdd}
      type="skills"
    />
  );
};

export default FilterSkill;
